import SolrFq from './SolrFq';
import SolrQuery from './SolrQuery';
import SolrSort from './SorlSort';

export function getCards(contentTypes: Array<string>) {
  const fq = SolrFq.or().pushGroup('_type_s', contentTypes);
  return SolrQuery.resourceCenter().setFq(fq).setSort(SolrSort.articleDate()).setRange({
    start: 0,
    rows: 3,
  });
}
